import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
function usePrevious(value) {
  const $ = _c(3);
  const [previous, setPrevious] = useState(null);
  let t0;
  let t1;
  if ($[0] !== value) {
    t0 = () => () => {
      setPrevious(value);
    };
    t1 = [value];
    $[0] = value;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return previous;
}
export default usePrevious;